import { httpClient } from '@/services/http/httpClient'

type GetPortfolioProjectData = {
  projectId: string
}

export type ProjectStep = {
  id: string
  title: string
  position: number
  currentStep: boolean
  isCompleted: boolean
}

export type PortfolioProject = {
  id: string
  portfolioColumnId: string
  title: string
  description: string
  positionOnColumn: number
  status: string
  priority: string
  startDate?: string | null
  endDate?: string | null
  ownerId: string
  responsibleId: string | null
  tennantId: string
  privacy: string
  createdAt: string
  updatedAt: string
  portfolioName: string
  progressTask: number
  deletedAt: string | null
  portfolioId: string | null
  horizontTagProject: {
    id: string
    color: string
    textColor: string
    name: string
  } | null
  riscTagProject: {
    id: string
    color: string
    textColor: string
    name: string
  } | null
  owner: {
    id: string
    name: string
    email: string
    image: string | null
  }
  responsible: {
    id: string
    name: string
    email: string
    image: string | null
  } | null
  projectUsers: {
    id: string
    name: string
    email: string
    image: string | null
    type: string
    status?: string
  }[]
  totalUsers: number
  projectTags: {
    id: string
    color: string
    textColor: string
    name: string
  }[]
  steps: {
    id: string
    title: string
    position: number
    currentStep: boolean
    isCompleted: boolean
  }[]
}

export async function getPortfolioProject({
  projectId,
}: GetPortfolioProjectData) {
  const { data } = await httpClient.get<PortfolioProject>(
    `/projects/portfolio-projects/${projectId}`,
  )

  return data
}
